// src/components/tables/GenericTable/TableRow.tsx

import React from "react";
import styled from "styled-components";

export interface TableRowProps {
  children: React.ReactNode;
  onClick?: () => void;
  selected?: boolean;
  hoverable?: boolean;
  compact?: boolean;
  columnTemplate?: string; // ✅ New
}

const StyledRow = styled.div<{
  selected?: boolean;
  hoverable?: boolean;
  compact?: boolean;
  columnTemplate?: string;
}>`
  display: grid;
  grid-template-columns: ${({ columnTemplate }) => columnTemplate || "auto"};
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm};
  padding: ${({ theme, compact }) =>
    compact ? `${theme.spacing.sm}` : `${theme.spacing.md}`};
  border-radius: ${({ theme }) => theme.radii.lg};
  background: ${({ theme }) => theme.colors.surface};
  box-shadow: ${({ theme }) => theme.elevations.low};
  transition: background 0.2s, box-shadow 0.2s;

  ${({ hoverable, theme }) =>
    hoverable &&
    `
    cursor: pointer;
    &:hover {
      background: ${theme.colors.surfaceHover};
      box-shadow: ${theme.elevations.md};
    }
  `}

  ${({ selected, theme }) =>
    selected &&
    `
    border: 2px solid ${theme.colors.primary};
  `}

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: ${({ theme }) => theme.spacing.xs};
    padding: ${({ theme }) => theme.spacing.sm};
  }
`;

export const TableRow: React.FC<TableRowProps> = ({
  children,
  onClick,
  selected = false,
  hoverable = true,
  compact = false,
  columnTemplate,
}) => {
  return (
    <StyledRow
      onClick={onClick}
      selected={selected}
      hoverable={hoverable}
      compact={compact}
      columnTemplate={columnTemplate}
    >
      {children}
    </StyledRow>
  );
};